// src/constants/ai.enums.ts

// Used in the frontend for UI logic, badge labels, and type-safe role-based filtering

export enum DmsAgentRole {
  PLANNER = 'PLANNER',
  RETRIEVER = 'RETRIEVER',
  SUMMARIZER = 'SUMMARIZER',
  CLASSIFIER = 'CLASSIFIER',
  PARSER = 'PARSER',
  POSTPROCESSOR = 'POSTPROCESSOR',
  OTHER = 'OTHER',
}

// Optional: if you want to loop or display friendly names
export const DmsAgentRoleLabels: Record<DmsAgentRole, string> = {
  [DmsAgentRole.PLANNER]: 'Planner',
  [DmsAgentRole.RETRIEVER]: 'Retriever',
  [DmsAgentRole.SUMMARIZER]: 'Summarizer',
  [DmsAgentRole.CLASSIFIER]: 'Classifier',
  [DmsAgentRole.PARSER]: 'Parser',
  [DmsAgentRole.POSTPROCESSOR]: 'Post-Processor',
  [DmsAgentRole.OTHER]: 'Other',
};
